import {
  SensorTagId,
  WEATHER_STATION_SOIL_MOISTURE_SENSOR_TAG_IDS,
  WEATHER_STATION_SOIL_TEMPERATURE_SENSOR_TAG_IDS
} from 'types/models/samplePoint';

export function isWeatherStationSoil(sensorTagId: SensorTagId) {
  return [
    ...WEATHER_STATION_SOIL_MOISTURE_SENSOR_TAG_IDS,
    ...WEATHER_STATION_SOIL_TEMPERATURE_SENSOR_TAG_IDS
  ].includes(sensorTagId);
}
